import { Injectable } from '@angular/core';
import { PageMetaService, TranslationService } from '@spartacus/core';
import { Observable, BehaviorSubject, isObservable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    private breadCrumbSource = new BehaviorSubject<any[]>([]);
    breadCrumbs$ = this.breadCrumbSource.asObservable();

    private breadCrumbTitleSource = new BehaviorSubject<string>('');
    breadCrumbTitle$ = this.breadCrumbTitleSource.asObservable();

    private isCustomBreadcrumbSource = new BehaviorSubject<boolean>(false);
    isCustomBreadcrumb$ = this.isCustomBreadcrumbSource.asObservable();

    private showBreadcrumbSource = new BehaviorSubject<boolean>(false);
    showBreadcrumb$ = this.showBreadcrumbSource.asObservable();

    constructor(
        protected pageMetaService: PageMetaService,
        private translation: TranslationService,
    ) {}

    setBreadCrumbs(crumbs: any[]) {
        this.isCustomBreadcrumbSource.next(true);

        this.translation.translate('common.home').subscribe((textHome) => {
            const home = [{ label: textHome, link: '/' }];
            this.breadCrumbSource.next([...home, ...crumbs]);
        });
    }

    setBreadcrumbTitle(title: string | Observable<string>) {
        this.isCustomBreadcrumbSource.next(true);
        
        if (isObservable(title)) {
            title.subscribe((res: string) => {
                this.breadCrumbTitleSource.next(res);
            });
        } else {
            this.breadCrumbTitleSource.next(title);
        }
    }

    setCustomBreadcrumbFlag(value: boolean) {
        this.isCustomBreadcrumbSource.next(value);
    }

    setShowHideBreadcrumb(value: boolean) {
        this.showBreadcrumbSource.next(value);
    }
}